import { injectable, inject } from 'inversify-props';
import { types } from '@/store';
import { Store } from 'vuex';
import { MealCountRequest } from '@/models';
import { ICounterApi } from '@/apis';
import { eventBus, mcEvents, mcLogger } from '@/utils';

export interface IMealLoader {
  loadServerMeals(request: MealCountRequest);
}

@injectable()
export class MealLoader {
  @inject() private counterApi!: ICounterApi;
  @inject() private store!: Store<any>;

  /** Fancy colored logger */
  private console: Console = mcLogger.getConsole(this.constructor.name, mcLogger.colors.MealLoader);

  /**
   * Gets any new/updated meal counts from server and saves them to store.
   * @param request
   */
  async loadServerMeals(request: MealCountRequest) {
    const response = await this.counterApi.syncMealsDown(request);
    if (response.status === 200) {
      await this.store.dispatch(types.actions.updateMultipleCountDtos, response.data.data.counts);
      await this.store.dispatch(types.actions.updateCountStatuses, response.data.data.countStatuses);
      eventBus.$emit(mcEvents.syncedMealsDown);
    }
  }
}

export const mealLoader = new MealLoader();
